import { Component, AfterViewInit, OnInit, computed, inject } from '@angular/core';
import { HeroComponent } from '../../components/hero/hero.component';
import { AboutComponent } from '../../components/about/about.component';
import { MenuComponent } from '../../components/menu/menu.component';
import { GalleryComponent } from '../../components/gallery/gallery.component';
import { TestimonialsComponent } from '../../components/testimonials/testimonials.component';
import { Reservation } from '../../components/reservation/reservation';
import { ContactComponent } from '../../components/contact/contact.component';
import { RestaurantConfigService } from '../../services/restaurant-config.service';
import { SeoService } from '../../services/seo.service';

@Component({
  selector: 'app-landing',
  imports: [
    HeroComponent,
    AboutComponent,
    MenuComponent,
    GalleryComponent,
    TestimonialsComponent,
    Reservation,
    ContactComponent,
  ],
  templateUrl: './landing.component.html',
  styleUrl: './landing.component.scss',
})
export class LandingComponent implements AfterViewInit, OnInit {
  private readonly restaurantConfig = inject(RestaurantConfigService);
  private readonly seo = inject(SeoService);

  readonly showReservation = computed(
    () => this.restaurantConfig.config().features.reservation
  );

  ngOnInit() {
    this.seo.setPageSeo({
      title: 'Kanyar Büfé Pákozd – Pacal és cseh sörök a Velencei-tónál',
      description:
        'Kanyar Büfé Pákozd – házias pacalpörkölt, magyaros frissensültek és válogatott cseh csapolt sörök a Velencei-tó partján. Minőségi alapanyagok, családbarát terasz, asztalfoglalás.',
      canonical: 'https://kanyarbufe.hu/',
    });
  }

  ngAfterViewInit() {
    this.initScrollAnimations();
  }

  private initScrollAnimations() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );

    document.querySelectorAll('.fade-in').forEach((el) => observer.observe(el));
  }
}
